import * as React from 'react';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import Toolbar from '@mui/material/Toolbar';
import Header from '../components/header/header';
import ElevationScroll from '../utilities/elevationScroll';
import Footer from '../components/footer/footer';
import { styled } from '@mui/material';
import { NavLink, Outlet, useLocation } from 'react-router-dom';
import RequestPageIcon from '@mui/icons-material/RequestPage';
import { RateFeeContext, rateFeeData, RateFeeDispatchContext } from '../context/rateFeeContext';
import { reducer } from '../reducer/rateFeeReducer';
import ListIcon from '@mui/icons-material/List';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';

const Image = styled("img")({
    maxWidth: "100%",
    height: "3rem",
});

const drawerWidth = 300;

const navigation = [
    {
        title: 'Activity Logs',
        icon: <ListIcon />,
        path: '/activity-logs',
    },
    {
        title: 'Macquarie Rates',
        icon: <TrendingUpIcon />,
        path: '/macquarieRates',
    },
    {
        title: 'Rate & Fees',
        icon: <RequestPageIcon />,
        path: '/rateFee',
    },   
    
];

export default function UserLayout() {
    const [state, dispatch] = React.useReducer(reducer, rateFeeData);
    const location = useLocation();
    const [mobileOpen, setMobileOpen] = React.useState(false);
    const [isClosing, setIsClosing] = React.useState(false);

    React.useEffect(() => {
        // Find the item in navigation that matches the current path
        const currentItem = navigation.find(item => item.path === location.pathname);
    
        // If a matching item is found, update the page title
        if (currentItem) {
          document.title = `${currentItem.title}`; // Update title
        }
      }, [location, navigation]);

    const handleDrawerClose = () => {
        setIsClosing(true);
        setMobileOpen(false);
    };

    const handleDrawerTransitionEnd = () => {
        setIsClosing(false);
    };

    const handleDrawerToggle = () => {
        if (!isClosing) {
            setMobileOpen(!mobileOpen);
        }
    };

    // const handleInterestRates = (state: any[]) =>{
    //     dispatch({type: 'updateRates'})
    // }

    const drawer = (
        <div>
            <List>
                {navigation.map((item, index) => (
                    <ListItem key={item.title} sx={{ p: 0 }}>
                        <ListItemButton component={NavLink} title={item.title} to={item.path} selected={location?.pathname === item.path} >
                            <ListItemIcon sx={{ minWidth: "auto", mr: 2 }}>
                                {item.icon}
                            </ListItemIcon>
                            <ListItemText primary={item.title} />
                        </ListItemButton>
                    </ListItem>
                ))}
            </List>
        </div>
    );

    // Remove this const when copying and pasting into your project.

    return (
        <>
            <Box sx={{ width: drawerWidth, height: "65px", bgcolor: "white", position: "fixed", display: "flex", alignItems: "center", justifyContent: "center", borderRight: { sm: 1 }, borderBottom: { xs: 1, sm: 1 }, borderColor: { xs: "#E8EAEE", sm: "#E8EAEE" }, top: 0, zIndex: mobileOpen ? 1201 : 1101 }}>
                <Image src="/assets/images/bidirectional.png" alt="Logo" />
            </Box>
            <Box sx={{ display: 'flex' }}>
                <IconButton
                    color="primary"
                    aria-label="open drawer"
                    edge="start"
                    onClick={handleDrawerToggle}
                    sx={{ px: 3, pt: 2.5, display: { sm: 'none' }, zIndex: mobileOpen ? 1202 : 1102, position: { xs: "fixed" } }}
                >
                    {mobileOpen ? <CloseIcon /> : <MenuIcon />}
                </IconButton>
                <ElevationScroll>
                    <Header drawerWidth={drawerWidth} isLoggedIn={true} />
                </ElevationScroll>
                <Box
                    component="nav"
                    sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
                    aria-label="mailbox folders"
                >
                    {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
                    <Drawer
                        variant="temporary"
                        open={mobileOpen}
                        onTransitionEnd={handleDrawerTransitionEnd}
                        onClose={handleDrawerClose}
                        ModalProps={{
                            keepMounted: true, // Better open performance on mobile.
                        }}
                        sx={{
                            display: { xs: 'block', sm: 'none' },
                            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth, top: "65px", height: "calc(100% - 65px)" },
                        }}
                    >
                        {drawer}
                    </Drawer>
                    <Drawer
                        variant="permanent"
                        sx={{
                            display: { xs: 'none', sm: 'block' },
                            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth, top: "65px", height: "calc(100% - 65px)" },
                        }}
                        open
                    >
                        {drawer}
                    </Drawer>
                </Box>
                <Box sx={{ flexGrow: 1, width: { sm: `calc(100% - ${drawerWidth}px)` }, minHeight: "calc(100vh)", display: "flex", flexDirection: "column", }}>
                    <Box
                        component="main">
                        <Toolbar />
                        <RateFeeContext.Provider value={state}>
                            <RateFeeDispatchContext.Provider value={dispatch}>
                                <Outlet />
                            </RateFeeDispatchContext.Provider>
                        </RateFeeContext.Provider>
                    </Box>
                    <Box sx={{ mt: 'auto' }}>
                        <Footer />
                    </Box>
                </Box>
            </Box>
        </>
    );
}

